<template>
	<div v-if="form.successful" class="notification is-success">
		<button v-if="dismissible" class="delete" @click="dismiss" />
		{{ message }}
	</div>
</template>

<script>
import Alert from 'vform/src/components/Alert'

export default {
	name: 'AlertSuccess',

	extends: Alert,

	props: {
		message: { type: String, default: '' }
	}
}
</script>
